import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { ExternalLink, BookOpen, Link2 } from "lucide-react";

export default function ProviderResources() {
  const [resources, setResources] = useState([]);
  const [customLinks, setCustomLinks] = useState([]);

  useEffect(() => {
    api.get("/resources").then(({ data }) => setResources(data));
    api.get("/system-links").then(({ data }) => {
      setCustomLinks(Array.isArray(data.custom_links) ? data.custom_links : []);
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="provider-resources">
      <div>
        <p className="text-label">Hub</p>
        <h2 className="font-display text-2xl font-bold tracking-tight">Resource Hub</h2>
        <p className="text-sm text-muted-foreground">Forms, references and downloads.</p>
      </div>

      <div className="space-y-3">
        {resources.length === 0 && customLinks.length === 0 && (
          <Card className="p-6 text-center text-sm text-muted-foreground">No resources yet.</Card>
        )}
        {resources.map((r) => (
          <a
            key={r.id}
            href={r.url}
            target="_blank"
            rel="noopener noreferrer"
            className="clinical-card p-4 flex items-center gap-3 hover:bg-secondary tap-target"
            data-testid={`resource-card-${r.id}`}
          >
            <div className="h-11 w-11 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
              <BookOpen className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-display font-semibold leading-tight">{r.title}</p>
              {r.description && <p className="text-xs text-muted-foreground truncate">{r.description}</p>}
            </div>
            <ExternalLink className="w-4 h-4 text-muted-foreground shrink-0" />
          </a>
        ))}
      </div>

      {/* v28 — Agency-wide custom links surfaced from System Link Manager */}
      {customLinks.length > 0 && (
        <div className="space-y-3" data-testid="agency-custom-links">
          <p className="text-label">Agency Links</p>
          {customLinks.map((c) => (
            <a
              key={c.id}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              className="clinical-card p-4 flex items-center gap-3 hover:bg-secondary tap-target"
              data-testid={`agency-link-${c.id}`}
            >
              <div className="h-11 w-11 rounded-md bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">
                <Link2 className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-display font-semibold leading-tight">{c.title}</p>
              </div>
              <ExternalLink className="w-4 h-4 text-muted-foreground shrink-0" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
